import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {__} from "~/ts/library/Translate";
import DataProviderLog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/DataProviderLog.vue";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DataProviderLogDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    platformId: {},
    authPrimaryId: {},
    entityTypeId: {},
    entityId: {},
    username: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {



let visible = _useModel<boolean>(__props, "visible");


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
    title: _unref(__)('Лог'),
    width: "900px",
    class: "body-background"
  }, {
    default: _withCtx(() => [
      _createVNode(DataProviderLog, {
        "platform-id": __props.platformId,
        "auth-primary-id": __props.authPrimaryId,
        "entity-type-id": __props.entityTypeId,
        "entity-id": __props.entityId,
        username: __props.username
      }, null, 8, ["platform-id", "auth-primary-id", "entity-type-id", "entity-id", "username"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})